// i18n 主文件
import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

// 从本地存储获取语言设置，默认使用中文
const getSavedLanguage = () => {
  return localStorage.getItem('language') || 'zh-CN'
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getSavedLanguage(),
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

/**
 * 切换语言
 * @param {string} lang - 语言代码，如 'zh-CN' 或 'en-US'
 */
export function switchLanguage(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('language', lang)
  console.log(`Language switched to: ${lang}`)
}

export default i18n